import { Pipe, PipeTransform } from '@angular/core';
import { CoordinateSource } from '../../../../models/coordinate-history';

@Pipe({
  name: 'typeCellIcon',
  standalone: true,
})
export class TypeCellPipe implements PipeTransform {
  transform(value: any): string {
    switch (value) {
      case CoordinateSource.CUSTOM:
        return 'assets/images/mapMarkers/cv_marker_custom_verified.png';
      case CoordinateSource.GEOCODE:
        return 'assets/images/mapMarkers/cv_marker_geocoded_verified.png';
      case CoordinateSource.IMPORT:
        return 'assets/images/mapMarkers/cv_marker_imported_verified.png';
      case CoordinateSource.GBP:
        return 'assets/images/mapMarkers/cv_marker_gbp_verified.png';
      default:
        return '';
    }
  }
}
